module.exports = __webpack_public_path__ + "img/Artboard 2.a0cd37ef.png";